<template>
  <section class="section-1">
    <div class="item">
      <div class="flex">
        <div class="header">
          <h3>{{ item.title }}</h3>
          <h4>
            <span v-for="topic in item.case_topics" :key="topic.id"
              >{{ topic.title }},
            </span>
          </h4>
        </div>
        <AddToBasketBtn class="basketBtn" :item="item" />
      </div>
    </div>

    <div class="description">
      <div v-html="item.description"></div>
      <h4>
        <span class="books" v-for="book in item.books" :key="book.id"
          >{{ book.title }},
        </span>
      </h4>
    </div>
    <div class="description">
      <div class="solvable" :class="{ green: item.solvable }">
        Die Lösungsskizze erscheint auf der generierten PDF.
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '../assets/css/_variables';
.section-1 {
  padding: 4em 8em;
  border-radius: 7px;
  margin-bottom: 60px;

  @media screen and (max-width: 640px) {
    padding: 1em;
  }
}

section {
  padding: 1em;
  color: $darkBlue;
  letter-spacing: 0.007em;
  line-height: 25px;

  div {
    position: relative;
  }
}

.item {
  position: relative;
  max-width: 800px;
  flex-basis: auto;
  flex-grow: 1;
  width: 100%;
  color: $darkBlue;
  margin-left: 35px;
  margin-bottom: 2em;
  .header {
    position: relative;
  }
  h3 {
    font-size: 2.5em;
    margin-bottom: 10px;
    user-select: none;
  }

  h4 {
    margin: 0px;
    opacity: 0.4;
  }
  h2 {
    color: $blue;
    position: relative;
    max-width: 800px;
    flex-basis: auto;
    flex-grow: 1;
    width: 100%;

    margin-bottom: 1em;
  }

  p {
    margin: 0px;
    width: 90%;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.description {
  max-width: 800px;
  background: #fff;
  padding: 2em;
  box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
  border-radius: 7px;
  margin-bottom: 60px;

  @media screen and (max-width: 640px) {
    padding: 1em;
  }
  .books {
    margin: 0.5rem;
    padding: 0.5rem;
    background: $background;
  }
}
.solvable {
  &::before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 4px;
    border-radius: 50%;
    background-color: rgb(220, 31, 31);
  }
  &.green {
    &::before {
      background-color: rgb(26, 183, 21);
    }
  }
}

.basketBtn {
  position: absolute;
  right: 45px;
  z-index: 2;

  @media screen and (max-width: 640px) {
    right: 17px;
    top: 40px;
  }
}
</style>

<script>
// import axios from 'axios';
import AddToBasketBtn from '../components/AddToBasketBtn.vue';

export default {
  name: 'Case',
  components: {
    AddToBasketBtn,
  },
  data() {
    return {
      item: null,
      parsedPreview: '',
      loader: null,
    };
  },
  methods: {
    parseCustomTags(line, formatTag, htmlTag) {
      const parts = line.split(formatTag);
      if (parts.length > 1) {
        line = parts[0];
        for (let i = 1; i < parts.length; i++) {
          line += (i % 2 == 1 ? `<${htmlTag}>` : `</${htmlTag}>`) + parts[i];
        }
        if (parts.length % 2 == 0) {
          line += `</${htmlTag}>`;
        }
      }
      return line;
    },
  },
  async mounted() {
    this.loader = this.$loading.show({});
    // this.item = (await axios.get(`${process.env.VUE_APP_BACKEND_URL}/getPDF?id=${this.$route.params.id}`)).data;
    this.item = await this.$api
      .get(`/cases/${this.$route.params.id}`, {
        params: {
          populate: ['case_topics', 'books'],
        },
      })
      .then((response) => {
        const transformedData = this.$find.transform(response.data);
        console.log(transformedData);
        return transformedData;
      });

    this.loader.hide();

    const parsedLines = [];

    //Parse Document Description Format
    const lines = this.item.description.split('\n');
    for (let i in lines) {
      let line = lines[i];

      if (line == '') {
        parsedLines.push('<br/>');
        continue;
      }

      if (i == 0) {
        line = this.parseCustomTags(line, '%', 'h1');
      } else {
        line = this.parseCustomTags(line, '%', 'b');
      }
      line = this.parseCustomTags(line, '&', 'i');

      //line = line.replace("TABTAB", `<span style="margin-left: 2em; margin-right: 0.25em;"></span>`);
      //line = line.replace("TAB", `<span style="margin-left: 1em; margin-right: 0.25em;"></span>`);
      if (line.startsWith('TAB')) {
        const twoTabs = line.startsWith('TABTAB');
        line = line.replace('TAB', '').replace('TAB', '');
        line = `<p style="margin-left: ${twoTabs ? 2 : 1}em">${line}</p>`;
      } else {
        const hasMargin = line.includes('<b>');
        line = `<span ${
          hasMargin ? 'style="margin-bottom: 0.25em"' : ''
        }>${line}</span>`;
      }

      parsedLines.push(line);
    }
    this.parsedPreview = parsedLines.join('\n');
  },
};
</script>
